























































import Vue from 'vue'
import VwRow from '@/components/VwRow.vue'
import { devlst_vmode_t, dev_property_t, THUMB_SIZE_VW, thumb_size_t } from '@/store/modules/pref'
import { Extender } from '@/types/api'
import { ppp, SORT_BY_NAME_FN } from '@/utils'
import { IDevice, IVW } from '@/types/model'
import easyapi from '@/easyapi'
import { reqMan } from '@/singleton'

export default Vue.extend({
  data (): {
    THUMB_SIZE_VW: thumb_size_t[]
  } {
    return {
      THUMB_SIZE_VW
    }
  },
  components: {
    VwRow,
  },
  computed: {
    vwList (): IVW[] { return this.$s.device.getters.vwList },
    sortedVwList (): IVW[] { return this.vwList.slice().sort(SORT_BY_NAME_FN) },
    thumbSize: {
      get (): thumb_size_t { return this.$s.$state.pref.vw.thumbSize },
      set (x: thumb_size_t): void { this.$s.pref.mutations.assignVW({ thumbSize: x }) }
    },
  },
  methods: {
    clickLeftIcon () { this.$router.go(-1) },
    createVW () { this.$router.push({ name: 'vwlst_create' }) }
  },
  watch: {
    //
  },
  mounted () {
    reqMan.ensureWsAvailable(() => {
      easyapi.getAllVw()
    })
  }
})
